import React, { Component } from "react";
import { Col, Image, Modal, Row, Tabs, Tag, Tooltip } from "antd";
import currencyFormat from "../../helper/currencyFormat";
import moment from "moment";

class ModalDetailLoan extends Component<any, any> {
  private readonly initState!: any;

  constructor(props: any) {
    super(props);

    this.initState = {
      dataOrder: this.props.dataOrder ? this.props.dataOrder : {},
    };
    this.state = { ...this.initState };
  }

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
  };

  render() {
    const dataLoan = this.props.dataLoan;

    return (
      <Modal title="Detail Loan" visible={this.props.visible} onCancel={this.props.onClose} footer={null} width={900}>
        {dataLoan && (
          <Tabs defaultActiveKey="1" style={{ margin: 0, padding: 0 }}>
            <Tabs.TabPane tab="Data Loan" key="1">
              <Row>
                <Col xl={{ span: 10 }} lg={{ span: 10 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tipe Transaksi </Col>
                    <Col span={14}>
                      :&nbsp;<strong>{dataLoan.transaction_type}</strong>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}> Dealer</Col>
                    <Col span={14}>
                      :&nbsp;{dataLoan.branch_code} - {dataLoan.branch_name}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Kode Loan</Col>
                    <Col span={14}>
                      :&nbsp;
                      <Tooltip title="Click untuk copy">
                        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={(event) => this.copyToClipboard(dataLoan.loan_code)}>
                          {dataLoan.loan_code}
                        </span>
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>No BPKB</Col>
                    <Col span={14}>
                      :&nbsp;
                      <Tooltip title="Click untuk copy">
                        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={(event) => this.copyToClipboard(dataLoan.bpkb_number)}>
                          {dataLoan.bpkb_number}
                        </span>
                      </Tooltip>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={10}>Waktu Buat Order</Col>
                    <Col span={14}>:&nbsp;{moment(dataLoan.created_date).format("YYYY-MM-DD HH:mm:ss")}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Status Loan</Col>
                    <Col span={14}>
                      :&nbsp;<Tag color="#cd201f">{dataLoan.status}</Tag>
                    </Col>
                  </Row>
                  {/* <Row gutter={[16, 16]}>
                    <Col span={10}>Sumber Order</Col>
                    <Col span={14}>
                      :&nbsp;{dataLoan.order_source} - {dataLoan.detail_order_source}
                    </Col>
                  </Row> */}
                  <br />
                  <Row gutter={[16, 16]}>
                    <Col span={10}>No PO </Col>
                    <Col span={14}>:&nbsp;{dataLoan.leasing_po_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>No Kontrak</Col>
                    <Col span={14}>:&nbsp;{dataLoan.leasing_contract_number}</Col>
                  </Row>
                  <br />
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Total Pencairan</Col>
                    <Col span={14}>:&nbsp;{currencyFormat(dataLoan.loan_amount)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tenor</Col>
                    <Col span={14}>:&nbsp;{dataLoan.loan_tenor}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tgl Expired Loan</Col>
                    <Col span={14}>:&nbsp;{dataLoan.loan_expired_date}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nilai Angsuran</Col>
                    <Col span={14}>:&nbsp;{currencyFormat(dataLoan.loan_instalment)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Komisi Leasing</Col>
                    <Col span={14}>:&nbsp;{currencyFormat(dataLoan.leasing_incentive || 0)}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Komisi Agen</Col>
                    <Col span={14}>:&nbsp;{currencyFormat(dataLoan.marketing_incentive)}</Col>
                  </Row>
                </Col>
                <Col xl={{ span: 13 }} lg={{ span: 13 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Kode Agen</Col>
                    <Col span={14}>:&nbsp;{dataLoan.marketing_agen_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nama Agen</Col>
                    <Col span={14}>:&nbsp;{dataLoan.marketing_agen_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nama Rekening Bank</Col>
                    <Col span={14}>:&nbsp;{dataLoan.marketing_bank_account_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nomor Rekening Bank</Col>
                    <Col span={14}>:&nbsp;{dataLoan.marketing_bank_account_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Bank Provider</Col>
                    <Col span={14}>
                      :&nbsp;
                      <strong>
                        {dataLoan.marketing_bank_provider_code} - {dataLoan.marketing_bank_provider_name}
                      </strong>
                    </Col>
                  </Row>
                  <br />
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Kode Leasing</Col>
                    <Col span={14}>:&nbsp;{dataLoan.leasing_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nama Leasing</Col>
                    <Col span={14}>:&nbsp;{dataLoan.leasing_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nama Rekening Bank</Col>
                    <Col span={14}>:&nbsp;{dataLoan.leasing_bank_account_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nomor Rekening Bank</Col>
                    <Col span={14}>:&nbsp;{dataLoan.leasing_bank_account_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Bank Provider</Col>
                    <Col span={14}>
                      :&nbsp;
                      <strong>
                        {dataLoan.leasing_bank_provider_code} - {dataLoan.leasing_bank_provider_name}
                      </strong>
                    </Col>
                  </Row>

                  <br />
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Offer Code</Col>
                    <Col span={14}>:&nbsp;{dataLoan?.additional_data?.offer_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tgl Buat Offer</Col>
                    <Col span={14}>:&nbsp;{moment(dataLoan?.additional_data?.offer_created_date).format("YYYY-MM-DD")}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tgl QC Offer</Col>
                    <Col span={14}>:&nbsp;{moment(dataLoan?.additional_data?.offer_qc_date).format("YYYY-MM-DD")}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Kode Komisi</Col>
                    <Col span={14}>:&nbsp;{dataLoan?.additional_data?.commission_code}</Col>
                  </Row>
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Data Konsumen" key="2">
              <Row>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>No Identitas</Col>
                    <Col span={16}>:&nbsp;{dataLoan.customer_identity_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Nama Konsumen</Col>
                    <Col span={16}>:&nbsp;{dataLoan.customer_name}</Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={8}>No telepon</Col>
                    <Col span={16}>:&nbsp;{dataLoan.customer_phone}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>Email</Col>
                    <Col span={16}>:&nbsp;{dataLoan.customer_email}</Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={8}>Alamat</Col>
                    <Col span={16}>
                      :&nbsp;
                      {dataLoan.customer_address}
                      <br />
                      &nbsp;&nbsp;Provinsi {dataLoan.customer_province_name}, <br />
                      &nbsp;&nbsp;Kota/Kab {dataLoan.customer_city_name}, <br />
                      &nbsp;&nbsp;Kec. {dataLoan.customer_district_name}, <br />
                      &nbsp;&nbsp;Kel. {dataLoan.customer_sub_district_name}, <br />
                      &nbsp;&nbsp;Kode Pos {dataLoan.customer_postal_code}
                      <br />
                    </Col>
                  </Row>
                </Col>
                <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingLeft: 10 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nama Rekening Bank</Col>
                    <Col span={14}>
                      :&nbsp;
                      <span style={{ textDecoration: "underline" }}>{dataLoan.customer_bank_account_name}</span>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nomor Rekening Bank</Col>
                    <Col span={14}>
                      :&nbsp;
                      <span style={{ textDecoration: "underline" }}>{dataLoan.customer_bank_account_number}</span>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}> Bank Provider</Col>
                    <Col span={14}>
                      :&nbsp;
                      <strong>
                        {dataLoan.customer_bank_provider_code} - {dataLoan.customer_bank_provider_name}
                      </strong>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Data Kendaraan" key="3">
              <Row>
                <Col xl={{ span: 15 }} lg={{ span: 15 }} md={{ span: 15 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nomor Polisi</Col>
                    <Col span={14}>:&nbsp;{dataLoan.plate_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nomor Mesin</Col>
                    <Col span={14}>:&nbsp;{dataLoan.engine_number}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Merk</Col>
                    <Col span={14}>:&nbsp;{dataLoan.brand_name}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Model</Col>
                    <Col span={14}>
                      :&nbsp;{dataLoan.class} - {dataLoan.model_name}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Variant</Col>
                    <Col span={14}>
                      :&nbsp;{dataLoan.variant_code} - {dataLoan.variant_name}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Nomor Rangka</Col>
                    <Col span={14}>:&nbsp;{dataLoan.chassis_number}</Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={10}>Warna</Col>
                    <Col span={14}>:&nbsp;{dataLoan.color_name}</Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={10}>Kode Manufaktur&nbsp;</Col>
                    <Col span={14}>:&nbsp;{dataLoan.manufacturer_code}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={10}>Tahun Manufaktur</Col>
                    <Col span={14}>:&nbsp;{dataLoan.manufacture_year}</Col>
                  </Row>
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Galeri Dokumen" key="4">
              <Row>
                {dataLoan?.document_asset?.map((doc: any, index: number) => (
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    {/* URL : {doc.url} <br />
                    IMAGE : {doc.image} */}
                    <Image key={index} src={doc.url} alt={doc.type} width="100%" style={{ padding: "10px" }} />
                  </Col>
                ))}
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Log Tagihan Robobill" key="5">
              <Row>
                <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={6}>ID Komisi Agen</Col>
                    <Col span={18}>:&nbsp;{dataLoan?.additional_data?.response_robobill?.invoice_marketing_incentive}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={6}>ID Komisi Leasing</Col>
                    <Col span={18}>:&nbsp;{dataLoan?.additional_data?.response_robobill?.invoice_leasing_incentive}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={6}>ID Dana Leasing</Col>
                    <Col span={18}>:&nbsp;{dataLoan?.additional_data?.response_robobill?.invoice_leasing_dana}</Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={6}>ID Dana Konsumen</Col>
                    <Col span={18}>:&nbsp;{dataLoan?.additional_data?.response_robobill?.invoice_customer_dana}</Col>
                  </Row>
                </Col>
              </Row>
            </Tabs.TabPane>
          </Tabs>
        )}
      </Modal>
    );
  }
}

export default ModalDetailLoan;
